import { render, staticRenderFns } from "./AccountModalRegisterFooter.vue?vue&type=template&id=3c0abfe4&scoped=true&"
import script from "./AccountModalRegisterFooter.vue?vue&type=script&lang=js&"
export * from "./AccountModalRegisterFooter.vue?vue&type=script&lang=js&"
import style0 from "./AccountModalRegisterFooter.vue?vue&type=style&index=0&id=3c0abfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0abfe4",
  null
  
)

export default component.exports